import { Link } from "@amzn/awsui-components-react";
import { RedriveRequestItem, RedriveStatus } from "../../../types";
import HealthStatusIndicator from "../../common/HealthStatusIndicator";

export const compareDates = (date1: string, date2: string): number => {
  const parseDate = (dateStr: string): Date => {
    try {
      const [datePart, timePart] = dateStr.split(", ");
      if (!datePart || !timePart) throw new Error("Invalid date format");

      const [day, month, year] = datePart.split("/").map(Number);
      const [hours, minutes, seconds] = timePart.split(":").map(Number);

      if ([day, month, year, hours, minutes, seconds].some(isNaN)) {
        throw new Error("Invalid date components");
      }

      return new Date(year, month - 1, day, hours, minutes, seconds);
    } catch (error) {
      console.error(`Error parsing date: ${dateStr}`, error);
      return new Date(dateStr); // fallback to epoch time or handle as needed
    }
  };

  const d1 = parseDate(date1);
  const d2 = parseDate(date2);

  return d1.getTime() - d2.getTime();
};

export const getColumnDefinitions = (
  onSelectExecution?: (executionId: string) => void
) => [
  {
    id: "executionId",
    header: "Execution ID",
    width: 550,
    cell: (item: RedriveRequestItem) => (
      <Link
        href={`?stage=${encodeURIComponent(
          item.stage
        )}&executionId=${encodeURIComponent(item.executionId)}`}
        onFollow={(event) => {
          // Client-side nav to avoid a full reload that would drop loaded state.
          if (onSelectExecution && item.executionId) {
            event.preventDefault();
            onSelectExecution(item.executionId);
          }
        }}
      >
        {item.executionId || "-"}
      </Link>
    ),
    sortingField: "executionId",
  },
  {
    id: "stage",
    header: "Stage",
    width: 100,
    cell: (item: RedriveRequestItem) => item.stage || "unknown",
    sortingField: "stage",
  },
  {
    id: "orderCount",
    header: "Orders Redriven",
    width: 200,
    cell: (item: RedriveRequestItem) => item.orderCount || "unknown",
    sortingField: "orderCount",
  },
  {
    id: "executor",
    header: "Executor",
    cell: (item: RedriveRequestItem) => item.executor || "unknown",
    sortingField: "executor",
  },
  {
    id: "status",
    header: "Status",
    cell: (item: RedriveRequestItem) => (
      <HealthStatusIndicator healthStatus={item.status as RedriveStatus} />
    ),
    sortingField: "status",
  },
  {
    id: "executionDate",
    header: "Request Date",
    cell: (item: RedriveRequestItem) =>
      new Date(item.executionDate).toLocaleString() || "-",
    sortingField: "date",
    sortingComparator: (a, b) => compareDates(a.executionDate, b.executionDate),
  },
];
